import { useQuery } from '@tanstack/react-query';

import { getRolesOfUser } from '../../services/adminService';

const useGetRolesOfUser = (userId: string) => {
    const {
        data,
        error,
        isFetching,
        isLoading,
        status,
        isError,
        refetch,
        isPending,
    } = useQuery({
        queryKey: ['admin-roles', userId],
        queryFn: () => getRolesOfUser(userId!),
        refetchOnWindowFocus: true,
        enabled: !!userId,
    });

    return {
        data,
        error,
        isFetching,
        isLoading,
        isError,
        status,
        refetch,
        isPending,
    };
};

export default useGetRolesOfUser;
